/**
 * Asyncronously run Promises in an object { string_label: Promise, ... }
 * Returns the object, but with the results in place of their Promises.
 * 
 * @see https://github.com/chandru89new/js-cookbook/blob/main/parallel-promises.md
 * @param promises: Object{label:Promise}
 * @returns Object{label: result}
 */
export default async function (promises) {
  let promiseList = Object.entries(promises).map(async ([name, promise]) => {
    let res
    try {
      res = { data: await promise() }
    } catch (e) {
      res = { error: e }
    }
    return [name, res]
  })

  let intermediateResult = []

  for (let p of promiseList) {
    await intermediateResult.push(await p)
  }

  intermediateResult.forEach((result)=>{
    if(result[1].hasOwnProperty('data')){
      //assume axios and hoist data upward
      let hoistedData = result[1]?.data?.data
      if(hoistedData) { result[1] = hoistedData }
    }
    // let tmpData = hoistData(result[1])
    return result
  })

  return Object.fromEntries(intermediateResult)
}

export async function runPromises2(promises) {
  console.log('run promises2', promises)
  const promisesArray = Object.entries(promises)
  Promise.allSettled(promisesArray).then((results) =>
    results.forEach(async (result) => {
      console.log(result.status)
      console.log('result', result)
    }),
  )
}